import { useGridApiContext } from '@mui/x-data-grid-pro';
import { ZeroStateFiltered } from './ZeroStateFiltered';
import { ZeroStateUpload } from './ZeroStateUpload';

export const ZeroStateOverlay = () => {
  const apiReference = useGridApiContext();
  const filterModel = apiReference.current.state.filter.filterModel;
  const hasActiveFilters = filterModel.items.length > 0;

  if (hasActiveFilters) {
    return <ZeroStateFiltered />;
  }

  return <ZeroStateUpload />;
};
